export class BaseEntityService<T> {
    constructor(private readonly entityConstructor: new (data) => T) {}

    initEntities(dataSet: any): T[] {
        return Array.isArray(dataSet) ? dataSet.map(data => new this.entityConstructor(data)) : [];
    }

    initEntity(data: any): T {
        return new this.entityConstructor(data);
    }

    initIfDataExists(data: any): T {
        return data ? new this.entityConstructor(data) : null;
    }
}
